import React from 'react';
import InfoCard from '../../common/InfoCard/InfoCard';
import AddInfoBlock from '../AddInfoBlock/AddInfoBlock';
import { texts } from '../../../constants/texts';
import { ReactComponent as DownloadIcon } from '../../../../../resource/DownloadIcon.svg';
import styles from './DownloadReport.module.scss';

const DownloadReport = ({
  onClick,
  text = texts.downloadReports,
  buttonProps = {},
}) => {
  return (
    <InfoCard>
      <AddInfoBlock
        {...buttonProps}
        text={text}
        iconComponent={() => <DownloadIcon className={styles.icon} />}
        onAddBtnClick={onClick}
      />
    </InfoCard>
  );
};

export default DownloadReport;
